import logo from './logo.svg';
import './App.css';
import { Routes, Route, Navigate, useLocation, useParams } from "react-router-dom";
import LoginPage from "./screens/Auth/Login";
import SignupPage from "./screens/Auth/CreateAccount";
import TostMessageComponent from "./TostMessageComponent/TostMessageComponent";
import DashboardScreen from './screens/Dashboard/dashboard';
import AssignmentsScreen from './screens/Dashboard/assignments';
import EnrollScreen from './screens/Dashboard/enroll';
import TimetableScreen from './screens/Dashboard/timetable';
import CreateChildScreen from './screens/Dashboard/create-child';
import ManageChildScreen from './screens/Dashboard/manage-child';
import ChooseChildPage from './screens/Auth/ChooseChild';
import ConfirmEnrollmentScreen from './screens/Dashboard/confirm-enrollment';
import MyClassesScreen from './screens/Dashboard/my-classes';
import ProfileScreen from './screens/Dashboard/profile';
import SubscriptionsScreen from './screens/Dashboard/subscriptions';
import ResetPage from './screens/Auth/ResetPassword';
import ChangePasswordPage from './screens/Auth/ChangePassword';
import ConfirmPrivateEnrollmentScreen from './screens/Dashboard/confirm-private-enrollment';
import AssignedClassesScreen from './screens/Dashboard/assigned-classes';
import MyStudentsScreen from './screens/Dashboard/my-students';
import EarningsScreen from './screens/Dashboard/earnings';
import CreateTaskScreen from './screens/Dashboard/create-task';
import EarningsHistoryScreen from './screens/Dashboard/earnings-history'
import EarningsPayoutScreen from './screens/Dashboard/earnings-payouts';
import MyAccountsScreen from './screens/Dashboard/all-accounts';
import MyTutorsScreen from './screens/Dashboard/all-tutors';
import TutorClassesScreen from './screens/Dashboard/tutor-classes';
import RevenueOverviewScreen from './screens/Dashboard/revenue-overview';
import RevGroupSubsScreen from './screens/Dashboard/group-subs';
import RevPrivateSubsScreen from './screens/Dashboard/private-subs';
import CreateLangScreen from './screens/Dashboard/create-language';
import LangListScreen from './screens/Dashboard/language-list';
import ClassGroupsScreen from './screens/Dashboard/class-groups';
import CreateGroupsScreen from './screens/Dashboard/create-groups';
import CreateTutorScreen from './screens/Dashboard/create-tutor';
import TutorProfileScreen from './screens/Dashboard/profile-settings';
import ClassPrivateScreen from './screens/Dashboard/class-private-schedule';
import CreatePrivateScreen from './screens/Dashboard/create-private-schedule';
import UploadMaterialScreen from './screens/Dashboard/upload-materials';
import InventoryScreen from './screens/Dashboard/materials-inventory';
import ShopSalesScreen from './screens/Dashboard/shop-sales';
import ChildProfileScreen from './screens/Dashboard/child-profile';
import MyTutorRequestsScreen from './screens/Dashboard/all-tutor-requests';
import AiAssistantScreen from './screens/Dashboard/ai_assistant';
import CreateParentScreen from './screens/Dashboard/create-parent';
import AdminAccountsScreen from './screens/Dashboard/admin-accounts';
import CreateAdminScreen from './screens/Dashboard/create-admin';
import EditMaterialScreen from './screens/Dashboard/edit-store-item';
import { UserContext } from './context/UserContext';
import { useContext, useEffect } from 'react';
import { useCookies } from 'react-cookie';

function App() {
  const {setUserProfile, logOutFunction, reloadUser} = useContext(UserContext);
  const [cookies, setCookie, removeCookie] = useCookies();
  const location = useLocation();
  const {token} = useParams();

  useEffect(() => {
    // console.log(location, location.pathname.split("/").filter(Boolean)[0]);
    if (location.pathname != "/login" && location.pathname != "/create-account" && location.pathname != "/select-child" && location.pathname != "/reset-password" && location.pathname.split("/").filter(Boolean)[0] != "change-password") {
      if (cookies?.userProfile != null) {
        setUserProfile(cookies?.userProfile);
      } else {
        logOutFunction();
      }
    }
  }, [])

  return (
    <div>
      <TostMessageComponent />
      <Routes>
        <Route exact path='/' element={<Navigate replace to='/login' />} />
        <Route exact path='/login' element={<LoginPage />} />
        <Route exact path='/reset-password' element={<ResetPage />} />
        <Route exact path='/change-password/:token' element={<ChangePasswordPage />} />
        <Route exact path='/login' element={<LoginPage />} />
        <Route exact path='/select-child' element={<ChooseChildPage />} />
        <Route exact path='/create-account' element={<SignupPage />} />
        <Route exact path='/home' element={<DashboardScreen />} />
        <Route exact path='/timetable' element={<TimetableScreen />} />
        <Route exact path='/assigned-classes' element={<AssignedClassesScreen />} />
        <Route exact path='/my-students' element={<MyStudentsScreen />} />
        <Route exact path='/all-accounts' element={<MyAccountsScreen />} />
        <Route exact path='/all-tutors' element={<MyTutorsScreen />} />
        <Route exact path='/tutor-classes' element={<TutorClassesScreen />} />
        <Route exact path='/enroll' element={<EnrollScreen />} />
        <Route exact path='/assigned-classes/tasks' element={<AssignmentsScreen />} />
        <Route exact path='/create-child' element={<CreateChildScreen />} />
        <Route exact path='/assigned-classes/tasks/create-task' element={<CreateTaskScreen />} />
        <Route exact path='/manage-child' element={<ManageChildScreen />} />
        <Route exact path='/enroll/confirm-enrollment' element={<ConfirmEnrollmentScreen />} />
        <Route exact path='/enroll/confirm-private-enrollment' element={<ConfirmPrivateEnrollmentScreen />} />
        <Route exact path='/subscriptions' element={<SubscriptionsScreen />} />
        <Route exact path='/earnings' element={<EarningsScreen />} />
        <Route exact path='/earnings/history' element={<EarningsHistoryScreen />} />
        <Route exact path='/earnings/payouts' element={<EarningsPayoutScreen />} />
        <Route exact path='/materials-inventory/edit' element={<EditMaterialScreen />} />
        <Route exact path='/revenue' element={<RevenueOverviewScreen />} />
        <Route exact path='/revenue/group-subs' element={<RevGroupSubsScreen />} />
        <Route exact path='/revenue/private-subs' element={<RevPrivateSubsScreen />} />
        <Route exact path='/languages' element={<LangListScreen />} />
        <Route exact path='/languages/create-language' element={<CreateLangScreen />} />
        <Route exact path='/class-groups' element={<ClassGroupsScreen />} />
        <Route exact path='/class-groups/create' element={<CreateGroupsScreen />} />
        <Route exact path='/all-tutors/create' element={<CreateTutorScreen />} />
        <Route exact path='/all-tutors/profile-settings' element={<TutorProfileScreen />} />
        <Route exact path='/private-schedule' element={<ClassPrivateScreen />} />
        <Route exact path='/private-schedule/create-class' element={<CreatePrivateScreen />} />
        <Route exact path='/upload-materials' element={<UploadMaterialScreen />} />
        <Route exact path='/materials-inventory' element={<InventoryScreen />} />
        <Route exact path='/shop-sales' element={<ShopSalesScreen />} />
        <Route exact path='/child-profile' element={<ChildProfileScreen />} />
        <Route exact path='/all-tutors/applications' element={<MyTutorRequestsScreen />} />
        <Route exact path='/ai/assistant' element={<AiAssistantScreen />} />
        <Route exact path='/all-accounts/create' element={<CreateParentScreen />} />
        <Route exact path='/admin-accounts' element={<AdminAccountsScreen />} />
        <Route exact path='/admin-accounts/create' element={<CreateAdminScreen />} />
        
        <Route exact path='/my-classes' element={<MyClassesScreen />} />
        <Route exact path='/my-profile' element={<ProfileScreen />} />
      </Routes>
    </div>
  );
}

export default App;
